import React from 'react';
import {Breadcrumb} from 'react-admin-base-nazox';
import {Link, Route, Routes} from "react-router-dom";
import {useFetch} from "react-admin-base";
import ChatBox from './ChatBox';
import { ChatWrapper } from './Socket';

function ReservationLeft({ row }) {
    return <Link to={"" + row.id}>
        <div className="d-flex">
            <div className="flex-1 overflow-hidden">
                <h5 className="text-truncate font-size-14 mb-1">
                    {row.name}
                </h5>
            </div>
            <div className="font-size-11">TEST</div>
        </div>
    </Link>;
}


export default function Edit() {
    return <ChatWrapper>
        <ChatPage />
    </ChatWrapper>;
}

function ChatPage() {
    const [reservation] = useFetch("/user?enabled=true");

    if (!reservation)
        return null;

    return <>
        <Breadcrumb
            title="Messages"
            data={
                [
                    {
                        href: '/message',
                        name: 'Messages'
                    }
                ]
            }
        />
            <div className="d-lg-flex mb-4">
                <div className="chat-leftsidebar">

                    <div className="tab-content py-4">
                        <div className="tab-pane show active" id="chat">
                            <div>
                                <h5 className="font-size-14 px-3 mb-3">Users</h5>
                                <ul className="list-unstyled chat-list">
                                    {
                                        reservation.data.map((row) =>
                                            <li key={row.id}>
                                                <ReservationLeft row={row} />
                                            </li>)
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <Routes>
                    <Route path=":id" element={<ChatBox />} />
                </Routes>
            </div>
    </>;
}
